import { createAction, props } from '@ngrx/store';
import { IError } from '../state/app.state';
import { IOrderData } from '@app/@shared/Models/order.model';

export const BeginGetOrderdItems = createAction('[ORDER] - GET ORDER ITEM INIT', props<{ requestBody: any }>());
export const GetOrderdItemsSuccess = createAction('[ORDER] - GET ORDERED ITEM SUCCESS', props<{ payload: IOrderData }>());
export const GetOrderdItemError = createAction('[ORDER] - GET ORDERED ITEM ERROR', props<{ payload: IError }>());